<template>
  <div v-if="!isLoading" class="page-wrapper">
    <div class="content-wrapper">
      <template v-if="list.length > 0">
        <div
          v-for="item in list"
          :key="item.id"
          class="item"
          @click="goDetail(item)"
        >
          <div class="info-top">
            <div class="left">{{ item.signTime }}</div>
            <div class="right">
              <div class="see">详情</div>
              <img class="icon-arrow" src="@/images/key_box/arrow-right.png" />
            </div>
          </div>
          <div class="address">门店地址：{{ item.address }}</div>
          <div :class="['status', 'status_' + item.status]">
            {{ item.statusDesc }}
          </div>
        </div>
      </template>

      <empty
        v-else
        :desc="'使用钥匙盒，货品放入门店内，配送更安全'"
        :type="1"
        :title="'您还没有钥匙盒'"
        :img="'Empty'"
        class="empty-box"
      ></empty>
    </div>
    <div v-if="!list.length" class="bottom-btn">
      <div class="btn" @click="addKey">申领钥匙盒</div>
    </div>
  </div>
</template>

<script>
// 连锁营业执照 其他执照列表 页面
import Empty from '@/common/layout/empty/index'
import { API } from '@/api'
import { navBar } from '@/utils/native_interactions/native_bar'
export default {
  components: { Empty },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const title = '钥匙盒'
      navBar.setTitle({
        text: title
      })
      document.title = title
      vm.getList()
    })
  },
  data() {
    return {
      list: [],
      isLoading: true
    }
  },
  computed: {},

  methods: {
    async getList() {
      this.isLoading = true
      try {
        const res = await API.account.configGetByKey({ key: 'keybox' })
        this.list = res?.list || []
        this.isLoading = false
      } catch (error) {
        this.$catch(error)
      }
    },
    addKey() {
      this.$track(this.$trackMap.keyBox.operateClick)
      this.$router.push({
        name: 'keyBoxDetail'
      })
    },
    goDetail(item) {
      this.$track(this.$trackMap.keyBox.goDetail)
      this.$router.push({
        name: 'keyBoxDetail',
        query: {
          signTime: item.signTime
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  background-color: #fff;
  height: 100vh;
  display: flex;
  flex-direction: column;
  .content-wrapper {
    flex: auto;
    height: 0;
    overflow: auto;
    padding: 0 16px;
    .item {
      padding: 16px 0;
      border-bottom: 1px solid #f5f5f5;
      background-color: #fff;
      .info-top {
        @include flex(row, space-between, center);
        .left {
          @include text-overflow-ellipsis-single;
          @include text(16px, #262626);
        }
        .right {
          @include flex-row-center;
          .see {
            @include text(14px, #595959);
          }
          .icon-arrow {
            width: 12px;
            height: 12px;
            margin-left: 4px;
          }
        }
      }
      .address {
        margin-top: 6px;
        @include text(14px, #999999);
      }
      .status {
        height: 14px;
        margin-top: 6px;
        padding: 2px 4px;
        border-radius: 2px;
        width: max-content;
        @include flex-column-center;
        &.status_1 {
          @include text(10px, #0daf52);
          background-color: #15bb5c1a;
          border: 1px solid #15bb5c80;
        }
        &.status_2 {
          @include text(10px, #ff9d21);
          background-color: #ff9d2126;
          border: 1px solid #ff9d2180;
        }
      }
    }
  }
  .empty-box {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .bottom-btn {
    padding: 6px 25px;
    @include iphonex-padding-bottom(6px);
    .btn {
      background-color: #15bb5c;
      height: 44px;
      border-radius: 40px;
      @include flex-row-center;
      @include text(16px, #fff);
    }
  }
}
</style>
